import { render } from "./TabsComponent.vue?vue&type=template&id=3e66dd36&scoped=true"
import script from "./TabsComponent.vue?vue&type=script&lang=js"
export * from "./TabsComponent.vue?vue&type=script&lang=js"

import "./TabsComponent.vue?vue&type=style&index=0&id=3e66dd36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e66dd36"]])

export default __exports__